export function CaseStudy() {
  return (
    <section aria-labelledby="case-study-heading">
      <h2 id="case-study-heading" className="section-heading">
        Caso de estudio
      </h2>
      <div className="panel">
        <p>
          Copias de JSON y CSV de producción pueden filtrar datos personales o identificadores indirectos.
          Data Anonymizer detecta campos candidatos, aplica reglas de máscara configurables manteniendo tipos y
          relaciones, y muestra una vista previa y un informe de cobertura antes de exportar — todo sin salir del
          navegador.
        </p>
        <p>
          <strong>Riesgo vigilado activamente:</strong> la falsa sensación de anonimato. El motor nunca certifica
          que un dataset quede "anonimizado"; solo aplica transformaciones configurables y advierte explícitamente
          cuando quedan campos candidatos sin cubrir o cuando varios cuasi-identificadores permanecen sin
          enmascarar a la vez (riesgo de combinación).
        </p>
        <p>
          Código, contratos, fixtures y pruebas en{" "}
          <a href="https://github.com/Aredex/data-anonymizer" target="_blank" rel="noreferrer">
            github.com/Aredex/data-anonymizer
          </a>
          .
        </p>
      </div>
    </section>
  );
}
